import React from 'react'
import classNames from 'classnames'
import { useHistory } from 'react-router'
import { useDispatch } from 'react-redux'

import useMobile from '../hooks/useMobile'
import styles from '../component-styles/onboarding-widget.module.scss'
import arrow from '../assets/right-arrow-pink.svg'
import ProgressBar from './progress-bar'
import Button from './button'
import onboardingSectionData from '../static-copy/onboarding-section-data.json'
import { saveUserData } from '../local-client/local-client'
import { calendarBookingLink } from '../core/variables'
import { logActionAsync } from '../store/actions'

interface Props {
  fullOnboardingSections: any
  setFullOnboardingSections: any
  setShowOnboardingWidget: any
  completedSections: number | null
  currentAccount: string
}

const OnboardingProgressWidget = React.memo(
  ({
    fullOnboardingSections,
    setFullOnboardingSections,
    setShowOnboardingWidget,
    completedSections,
    currentAccount,
  }: Props) => {
    const mobile = useMobile()

    const c = classNames(styles.widget, {
      [styles.mobile]: mobile,
    })

    const dispatch = useDispatch()

    const history = useHistory()

    if (
      fullOnboardingSections &&
      completedSections !== null &&
      completedSections < fullOnboardingSections.length
    ) {
      const nextTitleSlug =
        fullOnboardingSections.find((item) => {
          return !item.sectionCompleted || !item.sectionSkipped
        }).onboardingSectionID || 'View next task'

      const goToSection = () => {
        if (onboardingSectionData[nextTitleSlug].link) {
          if (onboardingSectionData[nextTitleSlug].link === 'bookSession') {
            window.open(calendarBookingLink, '_blank')
            const copy = [...fullOnboardingSections]
            const index = copy.findIndex(
              (section) => section.onboardingSectionID === nextTitleSlug,
            )
            copy[index].sectionCompleted = true
            setFullOnboardingSections(copy)
            dispatch(
              logActionAsync(onboardingSectionData[nextTitleSlug].actionData),
            )
          } else {
            history.push(onboardingSectionData[nextTitleSlug].link)
          }
        } else {
          // First step: go to onboarding page
          history.push('/welcome')
        }
      }

      return (
        <div className={c}>
          <div className={styles.row}>
            <div>
              <p>
                {completedSections} of {fullOnboardingSections.length}
                <Button
                  type="link"
                  style={{ height: 'auto' }}
                  onClick={goToSection}
                >
                  <span className={styles.pink}>
                    {onboardingSectionData[nextTitleSlug].title}
                  </span>
                </Button>
              </p>
              <ProgressBar
                percentage={Math.ceil(
                  (completedSections / fullOnboardingSections.length) * 100,
                )}
                showPercent={false}
                thin
                superThin
                green
              />
            </div>
            <Button type="none" onClick={goToSection} className={styles.button}>
              <img src={arrow} alt="Go to next section" />
            </Button>
          </div>
          <div className={styles.row}>
            <Button
              type="link"
              onClick={() => {
                setShowOnboardingWidget(false)
                saveUserData({ hideOnboardingWidget: true }, currentAccount)
              }}
              className={styles.hide}
            >
              Hide
            </Button>
            <Button type="link" to="/welcome" className={styles.viewAll}>
              View all
            </Button>
          </div>
        </div>
      )
    }

    return <></>
  },
)

export default OnboardingProgressWidget
